import { Controller } from '@hotwired/stimulus';
import { afterTransition } from '../lib/transition';

// Alerte fermable : la fermeture retire la classe qui l'affiche (`in` pour le
// fondu `.fade` d'un toast, `slide-in` pour un flash qui glisse hors de
// l'écran), puis enlève l'alerte du DOM une fois la transition finie.
//
// Attendus : `data-alert-shown-class` sur l'alerte, l'action `alert#close` sur
// le bouton de fermeture.
export default class AlertController extends Controller<HTMLElement> {
  static classes = ['shown'];

  declare readonly shownClass: string;

  close(): void {
    this.element.classList.remove(this.shownClass);
    afterTransition(this.element, () => this.element.remove());
  }
}
